import Button from '@/components/elements/Button';
import { ModalContent, ModalContentBody } from '@/components/elements/ModalContent';
import Flyout from '@/components/Flyout';
import UIResource from '@/components/UIResource';
import { resetAKFlowFully } from '@/ducks/accessKeys/utils';
import { useUIResource } from '@/ducks/common/resources';
import { useAppDispatch } from '@/store';
import tagmanager from '@/tagmanager';

import styles from './AccessKeyErrorModal.module.scss';

const AccessKeyErrorModal = () => {
  const dispatch = useAppDispatch();
  const clearLabel = useUIResource('AccessKey.clearCTA');

  const onCancel = () => {
    window.location.href = '/';
  };

  const onContinue = () => {
    tagmanager.tracker.common.trackIconClick({ labels: [clearLabel] });
    dispatch(resetAKFlowFully());
  };

  return (
    <Flyout className="-adaptive-height" direction="modal" hideCrossButton open>
      <ModalContent>
        <ModalContentBody>
          <h1>
            <UIResource id="VoyagePlanner.ItineraryResults.accessKeyInvalidPopup.title" />
          </h1>
          <p>
            <UIResource id="VoyagePlanner.ItineraryResults.accessKeyInvalidPopup.body" />
          </p>
          <div className={styles.actionButtons}>
            <Button onClick={onCancel} variant="secondary">
              <UIResource id="VoyagePlanner.ItineraryResults.accessKeyInvalidPopup.cancel" />
            </Button>
            <Button onClick={onContinue} variant="secondary">
              <UIResource id="VoyagePlanner.ItineraryResults.accessKeyInvalidPopup.continue" />
            </Button>
          </div>
        </ModalContentBody>
      </ModalContent>
    </Flyout>
  );
};

export default AccessKeyErrorModal;
